export enum RequestVerificationStatus {
    NOACTION = 0,
    PENDING = 1,
    APPROVED = 2,
    DISAPPROVED = 3,
    FORGIVEN = 4,
    REOPEN = 5,
    CANCELLED = 6,
    REQUEST_APPROVED=7,
    FOLLOWUP_REQUESTED=8,
    FOLLOWUP_SUBMITTED=9,
    FOLLOWUP_APPROVED=12,
    FOLLOWUP_FORGIVEN=14,
    FOLLOWUP_REOPENED=15,
    FOLLOWUP_DISAPPROVED=16,
    FOLLOWUP_DUE_DATE_CHANGED=17,
    SKIPPED = 18,
    CHANGE_MANAGER = 19,
    SUBMITTED = 10,
    COMPLETED = 11,
    NUDGED = 100,
    MESSAGE = 101,
    FINALIZED = 999
}